import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles.css';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import SurrenderIcon from '../../HOME/SVG/SurrenderIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TextIcon from '../../HOME/SVG/TextIcon';
import { REQUEST_SURRENDER_ON, REQUEST_RESET_STATS_OFF, SET_RESTART_ON } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { MODE_AI } from '../../HOME/const';
import { UNREPORT_INVALID_ACTION, SHOW_PILE } from '../REDUX/actions';

const Toolbar = props => {
  const dispatch = useDispatch();
  const [dummy, setDummy] = useState(false);
  const { pn } = useSelector(state => state);
  const ai = pn.mode === MODE_AI;

  useEffect(() => {
    const forceUpdate = () => setDummy(!dummy);
    window.addEventListener('resize', forceUpdate);

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [dummy]);

  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      if (pn.over) {
        dispatch(SET_RESTART_ON);
      } else {
        dispatch(REQUEST_SURRENDER_ON);
      }

      dispatch(REQUEST_RESET_STATS_OFF);
      dispatch(UNREPORT_INVALID_ACTION);
    }
  };

  const canSurrender = () => true;

  const handleShowPile = () => {
    dispatch({ type: SHOW_PILE, show: true });
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));
  const styles = { button: { marginLeft: margin, marginRight: margin } };

  return (
    <div className="toolbar">
      <span className="toolbar-button" style={styles.button} onClick={handleShowPile}>
        <TextIcon width="36" count={pn.inPileCount || ''} color="hotpink" />
      </span>
      <span className={`toolbar-button ${canSurrender() ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        {ai && !pn.over ? <SurrenderIcon width="36" /> : <RestartIcon width="36" />}
      </span>
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" />
      </span>
    </div>
  );
};

export default Toolbar;
